var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import Trigger from "./Trigger";
import Typography from "../Typography";
import { IconClose } from "../../icons";
import Button from "../Button";
export var Tooltip = function (props) {
    var _a;
    var title = props.title, content = props.content, _b = props.className, className = _b === void 0 ? "" : _b, children = props.children, _c = props.placement, placement = _c === void 0 ? "bottom" : _c, trigger = props.trigger, defaultOpen = props.defaultOpen, _d = props.colorType, colorType = _d === void 0 ? "white" : _d, _e = props.hideButtonOK, hideButtonOK = _e === void 0 ? false : _e, _f = props.hideButtonCancel, hideButtonCancel = _f === void 0 ? false : _f, buttonText = props.buttonText, _g = props.haveCloseIcon, haveCloseIcon = _g === void 0 ? false : _g, onOpenChange = props.onOpenChange, onClickOK = props.onClickOK, onClickCancel = props.onClickCancel, otherProps = __rest(props, ["title", "content", "className", "children", "placement", "trigger", "defaultOpen", "colorType", "hideButtonOK", "hideButtonCancel", "buttonText", "haveCloseIcon", "onOpenChange", "onClickOK", "onClickCancel"]);
    var buttonTextDefault = {
        ok: "OK",
        cancel: "CANCEL",
    };
    var buttonTextVar = __assign(__assign({}, buttonTextDefault), { buttonText: buttonText });
    var _h = useState(false), showTooltip = _h[0], setShowTooltip = _h[1];
    var handleOnClickClose = function () {
        setShowTooltip(!showTooltip);
    };
    var color = colorType !== "white" ? "-".concat(colorType) : "";
    var classNames = classnames((_a = {},
        _a["mex-tooltip".concat(color, "__popup")] = true,
        _a[className] = className,
        _a));
    var handleOnClickCancel = function () {
        handleOnClickClose();
        if (onClickCancel)
            onClickCancel();
    };
    var handleOnClickOK = function () {
        if (onClickOK)
            onClickOK();
        handleOnClickClose();
    };
    var handleVisiblePopup = function () {
        return !!(onClickCancel || onClickOK || haveCloseIcon);
    };
    var hideActions = useMemo(function () {
        return hideButtonCancel && hideButtonOK;
    }, [hideButtonCancel, hideButtonOK]);
    var popupElement = (_jsxs("div", __assign({ className: classNames }, { children: [haveCloseIcon && (_jsx("div", __assign({ className: "mex-tooltip__close", onClick: handleOnClickClose }, { children: _jsx(IconClose, { className: "mex-tooltip__close-icon" }) }))), title && (_jsx(Typography, __assign({ variant: "body01Semibold", className: "mex-tooltip".concat(color, "__popup-title") }, { children: title }))), typeof content === "string" ? (_jsx(Typography, __assign({ variant: "body01Regular", className: "mex-tooltip".concat(color, "__popup-inner-content") }, { children: content }))) : (content), !hideActions && (_jsxs("div", __assign({ className: "mex-tooltip__actions" }, { children: [!hideButtonCancel && (_jsx(Button, __assign({ weak: true, className: "mex-tooltip__action-button mex-tooltip__action-button-cancel", size: "small", onClick: handleOnClickCancel }, { children: buttonTextVar.cancel }))), !hideButtonOK && (_jsx(Button, __assign({ className: "mex-tooltip__action-button mex-tooltip__action-button-ok", size: "small", onClick: handleOnClickOK }, { children: buttonTextVar.ok })))] })))] })));
    return (_jsx(Trigger, __assign({ overlay: popupElement, placement: placement }, (handleVisiblePopup() && {
        visible: showTooltip,
    }), { onVisibleChange: function () {
            if (handleVisiblePopup()) {
                setShowTooltip(!showTooltip);
            }
            if (onOpenChange)
                onOpenChange(!showTooltip);
        }, trigger: trigger, defaultVisible: defaultOpen, colorType: colorType }, otherProps, { children: children })));
};
Tooltip.propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    placement: PropTypes.oneOf([
        "top",
        "left",
        "right",
        "bottom",
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight",
        "leftTop",
        "leftBottom",
        "rightTop",
        "rightBottom",
    ]),
    trigger: PropTypes.oneOf(["click", "hover", "focus", "contextMenu"]),
    defaultOpen: PropTypes.bool,
    className: PropTypes.string,
    colorType: PropTypes.oneOf(["white", "primary", "green"]),
    style: PropTypes.object,
    buttonText: PropTypes.object,
    onClickOK: PropTypes.func,
    onClickCancel: PropTypes.func,
    hideButtonOK: PropTypes.bool,
    hideButtonCancel: PropTypes.bool,
    onOpenChange: PropTypes.func,
    overlayClassName: PropTypes.string,
};
Tooltip.defaultProps = {
    placement: "bottom",
    trigger: "hover",
    colorType: "white",
};
export default Tooltip;
